import { t } from 'i18next';
import { MathplanJob } from '../../types/planung-graphql-client-defs';
import { apiHelper } from '../apiHelper';
import { showErrorToast } from '../toast';
import { ControlResult, GenericWarning } from './types';

type APIResponse<T> = {
  error?: string | null;
  data?: T;
};

export const testTimetableVersion = async (
  versionUuid: string,
  classes?: string[] | string,
): Promise<GenericWarning[]> => {
  return await apiHelper({
    path: `/test/timetableversion/${versionUuid}/${classes?.toString()}`,
    method: 'GET',
    type: 'json',
  });
};

export const controlTimetableVersion = async (
  versionUuid: string,
  classes?: string[] | string,
): Promise<ControlResult> => {
  return await apiHelper({
    path: `/control/timetable/${versionUuid}/${classes?.toString()}`,
    method: 'GET',
    type: 'json',
  });
};

export const solveTimetableVersionWithParams = async (
  versionUuid: string,
  options?: {
    classes: string[];
    includeRoomResources: boolean;
    keepExistingPositions: boolean;
    includeSubjectContainer: boolean;
  },
): Promise<APIResponse<MathplanJob> | undefined> => {
  return apiHelper({
    method: 'POST',
    path: `/mathplan/solve/${versionUuid}`,
    data: JSON.stringify(options),
    type: 'json',
  })
    .then((res) => {
      return { data: res as MathplanJob };
    })
    .catch((err) => {
      showErrorToast({ name: t('pinboard.generate.error'), message: err.cause ?? err.message, graphQLErrors: [] });
      return { error: err.message };
    });
};

export const exportTimetableVersionToAsc = async (versionUuid: string): Promise<string | undefined> => {
  return await apiHelper({
    method: 'GET',
    path: `/mathplan/asc/${versionUuid}`,
    type: 'xml',
  })
    .then((res) => res as string)
    .catch((err) => {
      showErrorToast({ name: t('pinboard.generate.error'), message: err.cause ?? err.message, graphQLErrors: [] });
      return undefined;
    });
};

export const cancelTimetableVersionGeneration = async (jobId: string): Promise<MathplanJob> => {
  return await apiHelper({
    path: `/mathplan/cancel/${jobId}`,
    method: 'POST',
    data: '',
    type: 'json',
  });
};

export const importTimetableVersionGeneration = async (jobId: string): Promise<MathplanJob> => {
  return await apiHelper({
    path: `/mathplan/import/${jobId}`,
    method: 'POST',
    data: '',
    type: 'json',
  });
};
